module.exports = __webpack_public_path__ + "img/Overview-pic.96aeeb8.jpg";